<div class="heritage">
  <div class="page-header">
    <div>
      <h2>文章管理</h2>
      <p>管理家族文化、家风故事、族谱来源等后台文章内容。</p>
    </div>
    <button type="button" class="primary-btn" :disabled="loading" @click="openCreate">
      新增文章
    </button>
  </div>

  <div v-if="errorMsg" class="error-banner">{{ errorMsg }}</div>

  <div class="toolbar">
    <input
      v-model="keyword"
      type="search"
      class="search-input"
      placeholder="搜索标题、摘要、作者"
      autocomplete="off"
      @input="handleSearchInput"
      @keyup.enter="handleSearch"
    />

    <select v-model="statusFilter" class="filter-select" :disabled="loading" @change="handleSearch">
      <option value="">全部状态</option>
      <option
        v-for="item in ARTICLE_STATUS_OPTIONS"
        :key="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </option>
    </select>

    <select v-model="categoryFilter" class="filter-select" :disabled="loading" @change="handleSearch">
      <option value="">全部分类</option>
      <option v-for="item in categoryOptions" :key="item.id" :value="item.id">
        {{ item.name }}
      </option>
    </select>

    <button type="button" class="secondary-btn" :disabled="loading" @click="handleSearch">
      查询
    </button>
    <button type="button" class="secondary-btn" :disabled="loading" @click="resetFilters">
      重置
    </button>
  </div>

  <div class="table-container">
    <div v-if="loading" class="loading-wrapper">
      <div class="loading-spinner"></div>
      <span>加载中...</span>
    </div>

    <div class="table-scroll">
      <table v-if="!loading" class="data-table">
        <thead>
          <tr>
            <th class="cover-col">封面</th>
            <th>ID</th>
            <th>标题</th>
            <th>分类</th>
            <th>作者</th>
            <th>来源</th>
            <th>地域</th>
            <th>状态</th>
            <th>精选</th>
            <th>推荐</th>
            <th>更新时间</th>
            <th class="action-col">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="articleList.length === 0">
            <td colspan="12" class="empty-text">暂无文章数据</td>
          </tr>
          <tr v-else v-for="item in articleList" :key="getId(item)">
            <td class="cover-col">
              <img v-if="item.cover_url" :src="item.cover_url" class="cover-thumb" alt="" />
              <span v-else class="cover-placeholder">无</span>
            </td>
            <td>{{ getId(item) }}</td>
            <td class="title-cell">
              <strong>{{ getTitle(item) }}</strong>
              <span v-if="item.subtitle">{{ item.subtitle }}</span>
            </td>
            <td>{{ getCategoryName(item) }}</td>
            <td>{{ item.author || '—' }}</td>
            <td>{{ getSourceTypeLabel(item.source_type) }}</td>
            <td>{{ item.region_name || item.surname || '—' }}</td>
            <td>
              <span class="status-tag" :class="'status-' + item.status">
                {{ getStatusLabel(item.status) }}
              </span>
            </td>
            <td>{{ formatBool(item.is_featured) }}</td>
            <td>{{ formatBool(item.is_recommended) }}</td>
            <td class="time-cell">{{ formatDate(item.updated_at || item.created_at) }}</td>
            <td class="action-col">
              <button type="button" class="action-btn edit-btn" @click="openEdit(item)">
                编辑
              </button>
              <button type="button" class="action-btn delete-btn" @click="handleDelete(item)">
                删除
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!loading && articleList.length > 0" class="pagination">
      <button
        type="button"
        class="page-btn"
        :disabled="currentPage <= 1"
        @click="handlePageChange(currentPage - 1)"
      >
        上一页
      </button>
      <span class="page-info">
        第 {{ currentPage }} / {{ totalPages }} 页 · 共 {{ total }} 条
      </span>
      <button
        type="button"
        class="page-btn"
        :disabled="currentPage >= totalPages"
        @click="handlePageChange(currentPage + 1)"
      >
        下一页
      </button>
    </div>
  </div>

  <div v-if="modalVisible" class="modal-mask" @click="closeModal">
    <div class="modal-panel" @click.stop>
      <div class="modal-header">
        <h3>{{ modalTitle }}</h3>
        <button type="button" class="link-btn" :disabled="saving" @click="closeModal">关闭</button>
      </div>

      <div v-if="detailLoading" class="modal-loading">详情加载中...</div>
      <div v-else class="form-body">
        <div class="form-grid">
          <label class="form-field">
            <span>标题 <em>*</em></span>
            <input v-model="articleForm.title" type="text" placeholder="文章标题" />
          </label>

          <label class="form-field">
            <span>分类 <em>*</em></span>
            <select v-model="articleForm.category_id">
              <option value="">请选择分类</option>
              <option v-for="item in categoryOptions" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </label>

          <label class="form-field">
            <span>副标题</span>
            <input v-model="articleForm.subtitle" type="text" placeholder="忠孝传家" />
          </label>

          <label class="form-field">
            <span>作者</span>
            <input v-model="articleForm.author" type="text" placeholder="管理员" />
          </label>

          <label class="form-field">
            <span>来源名称</span>
            <input v-model="articleForm.source_name" type="text" placeholder="族谱" />
          </label>

          <label class="form-field">
            <span>来源类型</span>
            <select v-model="articleForm.source_type">
              <option
                v-for="item in SOURCE_TYPE_OPTIONS"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </label>

          <label class="form-field">
            <span>姓氏</span>
            <input v-model="articleForm.surname" type="text" placeholder="陈" />
          </label>

          <label class="form-field">
            <span>朝代</span>
            <input v-model="articleForm.dynasty" type="text" placeholder="清代" />
          </label>

          <label class="form-field">
            <span>时期描述</span>
            <input v-model="articleForm.period_text" type="text" placeholder="清代中期" />
          </label>

          <label class="form-field">
            <span>地区编码</span>
            <input v-model="articleForm.region_code" type="text" placeholder="440000" />
          </label>

          <label class="form-field">
            <span>地区名称</span>
            <input v-model="articleForm.region_name" type="text" placeholder="广东" />
          </label>

          <label class="form-field">
            <span>状态</span>
            <select v-model="articleForm.status">
              <option
                v-for="item in ARTICLE_STATUS_OPTIONS"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </label>
        </div>

        <div class="image-upload-field full">
          <span class="field-label">封面</span>
          <div class="image-preview cover-preview">
            <img v-if="articleForm.cover_url" :src="articleForm.cover_url" alt="文章封面" />
            <span v-else>暂无封面</span>
          </div>
          <button
            type="button"
            class="mini-btn"
            :disabled="uploadingAsset"
            @click="triggerAssetUpload({ type: 'articleField', field: 'cover_url' }, 'image/*')"
          >
            {{ uploadingAsset ? '上传中...' : '上传封面' }}
          </button>
        </div>

        <label class="form-field full">
          <span>摘要</span>
          <textarea v-model="articleForm.summary" rows="3" placeholder="文章摘要"></textarea>
        </label>

        <div class="switch-row">
          <label>
            <input v-model="articleForm.is_featured" type="checkbox" />
            设为精选
          </label>
          <label>
            <input v-model="articleForm.is_recommended" type="checkbox" />
            设为推荐
          </label>
        </div>

        <section class="editor-section">
          <div class="section-header">
            <h4>标签</h4>
          </div>
          <div v-if="tagOptions.length" class="tag-check-list">
            <label v-for="item in tagOptions" :key="item.id" class="check-pill">
              <input v-model="selectedTagIds" type="checkbox" :value="item.id" />
              {{ item.name }}
            </label>
          </div>
          <p v-else class="empty-inline">暂无可选标签</p>
        </section>

        <section class="editor-section">
          <div class="section-header">
            <h4>正文内容</h4>
            <div class="block-tools">
              <button
                v-for="item in BLOCK_TYPE_OPTIONS"
                :key="item.value"
                type="button"
                class="mini-btn"
                @click.stop.prevent="addContentBlock(item.value)"
              >
                {{ item.label }}
              </button>
            </div>
          </div>

          <div v-if="contentBlocks.length === 0" class="empty-editor">
            点击上方按钮添加段落、小标题、图片、音频、视频、图集、时间线或引用。
          </div>

          <div
            v-for="(block, blockIndex) in contentBlocks"
            :key="block.id"
            class="content-block"
            :class="{ 'content-block--subheading': block.type === 'subheading' }"
            :data-block-id="block.id"
          >
            <div class="block-header">
              <strong>{{ getBlockTypeLabel(block.type) }}</strong>
              <div class="block-actions">
                <button type="button" class="text-btn" @click="moveContentBlock(blockIndex, -1)">上移</button>
                <button type="button" class="text-btn" @click="moveContentBlock(blockIndex, 1)">下移</button>
                <button type="button" class="text-btn danger" @click="removeContentBlock(blockIndex)">删除</button>
              </div>
            </div>

            <div v-if="block.type === 'paragraph'" class="form-field full compact">
              <span>段落正文</span>
              <textarea v-model="block.text" rows="4" placeholder="这是一段正文内容。"></textarea>
            </div>

            <div v-else-if="block.type === 'subheading'" class="form-field full compact subheading-field">
              <span>小标题</span>
              <input
                v-model="block.text"
                type="text"
                class="subheading-input"
                placeholder="如：一、历史背景"
              />
            </div>

            <div v-else-if="block.type === 'image'" class="form-grid compact-grid">
              <div class="image-upload-field">
                <span class="field-label">图片</span>
                <div class="image-preview cover-preview">
                  <img v-if="block.url" :src="block.url" alt="正文图片" />
                  <span v-else>暂无图片</span>
                </div>
                <button
                  type="button"
                  class="mini-btn"
                  :disabled="uploadingAsset"
                  @click="triggerAssetUpload({ type: 'blockField', blockIndex, field: 'url' }, 'image/*')"
                >
                  {{ uploadingAsset ? '上传中...' : '上传图片' }}
                </button>
              </div>
              <label class="form-field">
                <span>图片说明</span>
                <input v-model="block.caption" type="text" placeholder="老谱书影印页" />
              </label>
            </div>

            <div v-else-if="block.type === 'audio'" class="form-grid compact-grid">
              <label class="form-field">
                <span>音频 URL</span>
                <div class="upload-field">
                  <input v-model="block.url" type="text" readonly placeholder="上传后自动生成 URL" />
                  <button
                    type="button"
                    class="mini-btn"
                    :disabled="uploadingAsset"
                    @click="triggerAssetUpload({ type: 'blockField', blockIndex, field: 'url' }, 'audio/*')"
                  >
                    上传音频
                  </button>
                </div>
              </label>
              <label class="form-field">
                <span>标题</span>
                <input v-model="block.title" type="text" placeholder="后人口述采访" />
              </label>
              <label class="form-field">
                <span>时长（秒）</span>
                <input v-model.number="block.duration" type="number" min="0" step="1" placeholder="186" />
              </label>
              <div class="image-upload-field">
                <span class="field-label">封面</span>
                <div class="image-preview thumb-preview">
                  <img v-if="block.cover" :src="block.cover" alt="音频封面" />
                  <span v-else>暂无封面</span>
                </div>
                <button
                  type="button"
                  class="mini-btn"
                  :disabled="uploadingAsset"
                  @click="triggerAssetUpload({ type: 'blockField', blockIndex, field: 'cover' }, 'image/*')"
                >
                  上传封面
                </button>
              </div>
            </div>

            <div v-else-if="block.type === 'video'" class="form-grid compact-grid">
              <label class="form-field">
                <span>视频 URL</span>
                <div class="upload-field">
                  <input v-model="block.url" type="text" readonly placeholder="上传后自动生成 URL" />
                  <button
                    type="button"
                    class="mini-btn"
                    :disabled="uploadingAsset"
                    @click="triggerAssetUpload({ type: 'blockField', blockIndex, field: 'url' }, 'video/*')"
                  >
                    上传视频
                  </button>
                </div>
              </label>
              <label class="form-field">
                <span>标题</span>
                <input v-model="block.title" type="text" placeholder="宗祠修缮记录" />
              </label>
              <div class="image-upload-field full">
                <span class="field-label">封面图</span>
                <div class="image-preview cover-preview">
                  <img v-if="block.poster" :src="block.poster" alt="视频封面" />
                  <span v-else>暂无封面</span>
                </div>
                <button
                  type="button"
                  class="mini-btn"
                  :disabled="uploadingAsset"
                  @click="triggerAssetUpload({ type: 'blockField', blockIndex, field: 'poster' }, 'image/*')"
                >
                  上传封面
                </button>
              </div>
            </div>

            <div v-else-if="block.type === 'gallery'" class="nested-editor">
              <label class="form-field full compact">
                <span>图集标题</span>
                <input v-model="block.title" type="text" placeholder="旧谱图集" />
              </label>
              <div v-for="(item, itemIndex) in block.items" :key="itemIndex" class="nested-row">
                <div class="image-upload-compact">
                  <div class="image-preview thumb-preview">
                    <img v-if="item.url" :src="item.url" alt="" />
                    <span v-else>暂无</span>
                  </div>
                  <button
                    type="button"
                    class="mini-btn"
                    :disabled="uploadingAsset"
                    @click="triggerAssetUpload({ type: 'blockItemField', blockIndex, itemIndex, field: 'url' }, 'image/*')"
                  >
                    上传
                  </button>
                </div>
                <input v-model="item.caption" type="text" placeholder="说明" />
                <button type="button" class="text-btn danger" @click="removeBlockItem(block, itemIndex)">删除</button>
              </div>
              <button type="button" class="mini-btn" @click="addBlockItem(block)">添加图片</button>
            </div>

            <div v-else-if="block.type === 'timeline'" class="nested-editor">
              <label class="form-field full compact">
                <span>时间线标题</span>
                <input v-model="block.title" type="text" placeholder="人物生平时间线" />
              </label>
              <div v-for="(item, itemIndex) in block.items" :key="itemIndex" class="timeline-row">
                <input v-model="item.date" type="text" placeholder="1898" />
                <input v-model="item.title" type="text" placeholder="出生" />
                <input v-model="item.description" type="text" placeholder="出生于某地。" />
                <button type="button" class="text-btn danger" @click="removeBlockItem(block, itemIndex)">删除</button>
              </div>
              <button type="button" class="mini-btn" @click="addBlockItem(block)">添加节点</button>
            </div>

            <div v-else-if="block.type === 'quote'" class="form-grid compact-grid">
              <label class="form-field full">
                <span>引用内容</span>
                <textarea v-model="block.text" rows="3" placeholder="修身齐家，忠孝传家。"></textarea>
              </label>
              <label class="form-field full">
                <span>出处</span>
                <input v-model="block.source" type="text" placeholder="旧谱家训" />
              </label>
            </div>

            <div v-else class="form-field full compact unknown-block-hint">
              <span>暂不支持的内容块类型：{{ block.type || '未知' }}</span>
            </div>
          </div>
        </section>

        <section class="editor-section">
          <div class="section-header">
            <h4>关联人物</h4>
            <button type="button" class="mini-btn" @click="addPersonLink">添加人物</button>
          </div>
          <div v-if="personLinks.length === 0" class="empty-editor">暂无关联人物</div>
          <div v-for="(link, index) in personLinks" :key="index" class="relation-row">
            <select v-model="link.person_id">
              <option value="">选择人物</option>
              <option v-for="item in personOptions" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
            <input v-model="link.relation_type" type="text" placeholder="main" />
            <button type="button" class="text-btn danger" @click="removePersonLink(index)">删除</button>
          </div>
        </section>

        <section class="editor-section">
          <div class="section-header">
            <h4>媒体资源</h4>
            <button type="button" class="mini-btn" @click="addMediaItem">添加媒体</button>
          </div>
          <div v-if="mediaList.length === 0" class="empty-editor">暂无媒体资源</div>
          <div v-for="(item, index) in mediaList" :key="index" class="media-row">
            <select v-model="item.media_type">
              <option value="image">图片</option>
              <option value="audio">音频</option>
              <option value="video">视频</option>
            </select>
            <div class="upload-field compact-upload">
              <input v-model="item.url" type="text" readonly placeholder="上传后自动生成 URL" />
              <button
                type="button"
                class="mini-btn"
                :disabled="uploadingAsset"
                @click="triggerAssetUpload(
                  { type: 'mediaField', index, field: 'url' },
                  item.media_type === 'audio' ? 'audio/*' : item.media_type === 'video' ? 'video/*' : 'image/*'
                )"
              >
                上传
              </button>
            </div>
            <input v-model="item.title" type="text" placeholder="标题" />
            <input v-model.number="item.sort_order" type="number" min="0" step="1" placeholder="排序" />
            <button type="button" class="text-btn danger" @click="removeMediaItem(index)">删除</button>
          </div>
        </section>

        <section class="editor-section">
          <div class="section-header">
            <h4>图集</h4>
            <button type="button" class="mini-btn" @click="addGallery">添加图集</button>
          </div>
          <div v-if="galleryList.length === 0" class="empty-editor">暂无图集</div>
          <div v-for="(gallery, galleryIndex) in galleryList" :key="galleryIndex" class="gallery-editor">
            <div class="gallery-header">
              <input v-model="gallery.title" type="text" placeholder="图集标题" />
              <div class="image-upload-compact">
                <div class="image-preview thumb-preview">
                  <img v-if="gallery.cover_url" :src="gallery.cover_url" alt="" />
                  <span v-else>封面</span>
                </div>
                <button
                  type="button"
                  class="mini-btn"
                  :disabled="uploadingAsset"
                  @click="triggerAssetUpload({ type: 'galleryField', galleryIndex, field: 'cover_url' }, 'image/*')"
                >
                  上传封面
                </button>
              </div>
              <button type="button" class="text-btn danger" @click="removeGallery(galleryIndex)">删除图集</button>
            </div>
            <div v-for="(item, itemIndex) in gallery.items" :key="itemIndex" class="nested-row">
              <div class="image-upload-compact">
                <div class="image-preview thumb-preview">
                  <img v-if="item.image_url" :src="item.image_url" alt="" />
                  <span v-else>暂无</span>
                </div>
                <button
                  type="button"
                  class="mini-btn"
                  :disabled="uploadingAsset"
                  @click="triggerAssetUpload({ type: 'galleryItemField', galleryIndex, itemIndex, field: 'image_url' }, 'image/*')"
                >
                  上传
                </button>
              </div>
              <input v-model="item.caption" type="text" placeholder="说明" />
              <button type="button" class="text-btn danger" @click="removeGalleryItem(gallery, itemIndex)">删除</button>
            </div>
            <button type="button" class="mini-btn" @click="addGalleryItem(gallery)">添加图片</button>
          </div>
        </section>
      </div>

      <div class="modal-actions">
        <input
          ref="fileInputRef"
          class="hidden-input"
          type="file"
          :accept="uploadAccept"
          @change="handleSelectAsset"
        />
        <button type="button" class="secondary-btn" :disabled="saving" @click="closeModal">
          取消
        </button>
        <button type="button" class="primary-btn" :disabled="saving || detailLoading" @click="handleSave">
          {{ saving ? '保存中...' : '保存' }}
        </button>
      </div>
    </div>
  </div>
</div>
